import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCUToq0eKLJZP-wQQi1KBsWOYqJwyFpjxg",
  authDomain: "hqsecurity-d9121.firebaseapp.com",
  projectId: "hqsecurity-d9121",
  storageBucket: "hqsecurity-d9121.firebasestorage.app",
  messagingSenderId: "75910419208",
  appId: "1:75910419208:web:34ad7d4801a586c9fe92bd",
  measurementId: "G-PR8MYG0BP2"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;